import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { BitrixCompanyUsageDto } from "../../../dto/Bitrix/BitrixCompanyUsageDto";

type BitrixCompanyUsagePageState = {
  loading: boolean;
  requestFailed: boolean;
  result?: BitrixCompanyUsageDto;
};

const initialState: BitrixCompanyUsagePageState = {
  loading: false,
  requestFailed: false,
};

const bitrixCompanyUsageSlice = createSlice({
  name: "bitrixCompanyUsage",
  initialState,
  reducers: {
    checkCompanyUsage(state, _action: PayloadAction<number>) {
      state.loading = true;
      state.requestFailed = false;
      state.result = undefined;
    },
    checkCompanyUsageSuccess(state, action: PayloadAction<BitrixCompanyUsageDto>) {
      state.loading = false;
      state.result = action.payload;
    },
    checkCompanyUsageReject(state) {
      state.loading = false;
      state.requestFailed = true;
    },
  },
});

export default bitrixCompanyUsageSlice;
